// extracted by css-extract-rspack-plugin
export default {"dialogRoot":"TicketSolutionDialog_dialogRoot__H83Qc"};